import fontawesome from '@fortawesome/fontawesome';

// Social
import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF';
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';
import faFlickr from '@fortawesome/fontawesome-free-brands/faFlickr';
import faLinkedIn from '@fortawesome/fontawesome-free-brands/faLinkedIn';

// Solid
import faArrowDown from '@fortawesome/fontawesome-free-solid/faArrowDown';
import faArrowRight from '@fortawesome/fontawesome-free-solid/faArrowRight';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import faPlay from '@fortawesome/fontawesome-free-solid/faPlay';
import faAngleDoubleRight from '@fortawesome/fontawesome-free-solid/faAngleDoubleRight';
import faHome from '@fortawesome/fontawesome-free-solid/faHome';
import faBars from '@fortawesome/fontawesome-free-solid/faBars';
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus';
import faMinus from '@fortawesome/fontawesome-free-solid/faMinus';
import faFilePdf from '@fortawesome/fontawesome-free-solid/faFilePdf';
import faCaretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
import faCaretUp from '@fortawesome/fontawesome-free-solid/faCaretUp';
import faHeart from '@fortawesome/fontawesome-free-regular/faHeart';
import faExternalLinkAlt from '@fortawesome/fontawesome-free-solid/faExternalLinkAlt';

/**
 * Font Awesome Class
 */
class FontAwesome {
    /**
     * Initilization Function
     * @returns {void}
     */
    init() {
        this.loadFonts();
    }

    /**
     * Loads the fonts
     * @returns {void}
     */
    loadFonts() {
        const fontsToLoad = [
            faFacebookF,
            faTwitter,
            faInstagram,
            faFlickr,
            faLinkedIn,
            faArrowDown,
            faArrowRight,
            faAngleDoubleRight,
            faTimes,
            faPlay,
            faHome,
            faBars,
            faPlus,
            faMinus,
            faFilePdf,
            faCaretDown,
            faCaretUp,
            faHeart,
            faExternalLinkAlt
        ];
        fontawesome.library.add(fontsToLoad);
    }
}

export default FontAwesome;
